type config = {
  base_url?: string
}

export const Config: config = {
  base_url: "",
  // base_url: "http://localhost:8000",
  // base_url: "https://encoder.qbrick.com",
}